import { css } from 'lit';

export const styleSpinner = css`
  .grv-spinner {
    align-items: center;
    background-color: rgba(255, 255, 255, 1);
    color: #141414;
    display: flex;
    flex-flow: column-reverse;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    transition:
      opacity 0.25s ease-in,
      visibility 0.25s;
    width: 100%;
    z-index: 9999;
  }

  .grv-spinner::after {
    animation: grv-spinner__rotate 0.66s infinite ease-in-out;
    border: 4px solid #255f82;
    border-radius: 50%;
    border-top-color: transparent;
    box-sizing: border-box;
    content: '';
    display: block;
    height: 48px;
    transform: scale(1);
    transform-origin: 50% 50%;
    width: 48px;
  }

  span {
    font-size: 16px;
    margin-top: 24px;
  }

  @keyframes grv-spinner__rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
`;
